module.exports = __webpack_public_path__ + "img/3s.3006ba6c.png";